import React from "react";

import NavigationItem from "./NavigationItem/NavigationItem";

const navigationItems = (props) => {
  let navItemComponent = props.navItems.map((item, index) => (
    <NavigationItem key={index} link={item.link}>
      {item.name}
    </NavigationItem>
  ));

  if (props.place === "abstract") {
    navItemComponent = props.parsedAbstract.map((item) => (
      <NavigationItem link={item.tabTitle.toLowerCase().replace(" ", "-")}>
        {item.tabTitle}
      </NavigationItem>
    ));
  }

  return (
    <div className="d-flex px-2 align-items-center">{navItemComponent}</div>
  );
};

export default navigationItems;
